'use client';

import CustomLink from 'components/shared/CustomLink';
import Script from 'next/script';

import styles from './not-found-client.module.css';

function canCreateWebGLContext(): boolean {
  try {
    const canvas = document.createElement('canvas');
    return !!(canvas.getContext('webgl2') || canvas.getContext('webgl'));
  } catch {
    return false;
  }
}

function initUnicornStudio(): void {
  try {
    const studio = (window as any).UnicornStudio;
    if (!studio?.init || studio.isInitialized || !canCreateWebGLContext()) {
      return;
    }
    studio.init();
    studio.isInitialized = true;
  } catch {
    // WebGL unavailable — static copy still renders
  }
}

const Error404 = () => {
  return (
    <>
      <section className={styles.root}>
        <div
          data-us-project="noakedgDuwIq5D4oejui"
          style={{ width: '100%', height: '100%' }}
        ></div>

        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <p>
              Like you, we occasionally like to take uncharted paths and make
              something out of them. Let&apos;s be hopeful and navigate to
              something more familiar for now?
            </p>

            <CustomLink
              href={{
                pathname: '/',
              }}
            >
              Go back home
            </CustomLink>
          </div>
        </div>
      </section>
      <Script
        src={'https://cdn.unicorn.studio/v1.3.2/unicornStudio.umd.js'}
        strategy="lazyOnload"
        onLoad={initUnicornStudio}
      />
    </>
  );
};

export default Error404;
